import { CapoPlugin } from "/home/vsts/work/1/s/node_modules/.pnpm/@unhead+vue@1.11.19_vue@3.5.13/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];